require.register("registration/controllers/editCtrl", function(exports, require, module){
  $0
  
});

